import { type FormikErrors } from 'formik';

import { type TGlobalFunctionTyped } from 'src/core/common/hooks/useTranslation';

import type { FormValues } from './CostCenterDetailsContent';
import { type Setting } from '../../setting';

type FormErrors = FormikErrors<FormValues>;

export const validateCostCenterForm = (
  values: FormValues,
  translator: TGlobalFunctionTyped,
  settings: Setting[] | undefined,
  selectedSettings: Setting[] | undefined,
): FormErrors => {
  const errors: FormErrors = {};

  const otherSettings = settings?.filter(
    (s) => !selectedSettings?.some((sc) => sc.id === s.id),
  );

  const hasSameNameCostCenter = otherSettings?.find((s) => {
    return (
      s.name.toLowerCase() === values.name.toLowerCase() &&
      s.companyIds.every((companyId) =>
        values.targetCompanyIds.includes(companyId),
      )
    );
  });

  if (hasSameNameCostCenter) {
    errors.name = translator(
      'multiEntityHub.costCenters.modal.assignment.sameNameCostCenter',
    );
  }

  if (!values.name || values.name?.trim() === '') {
    errors.name = translator('costCenters.form.errors.nameEmpty');
  }

  if (!values.ownerId) {
    errors.ownerId = translator('costCenters.form.errors.ownerEmpty');
  }

  if (!values.targetCompanyIds.length) {
    errors.targetCompanyIds = translator('costCenters.form.errors.entityEmpty');
  }

  return errors;
};
